import React, { useEffect, useState, useRef } from "react";
import { ChevronDown, Loader2 } from "lucide-react";
import { REPORT_AREAS_API } from "../../apis/reportAreas";
import { showToast } from "../../utils/toastNotification";
import ExportButtons from "./ExportButtons";
import CustomSelect from "../base/CustomSelect";

export default function DomainFilter({ selectedDomain, onDomainChange, dateRange }) {
  const [domains, setDomains] = useState([]);
  const [loading, setLoading] = useState(false);
  const hasFetched = useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    const fetchDomains = async () => {
      setLoading(true);
      try {
        const response = await REPORT_AREAS_API.getAllReportAreas(
          1,
          100,
          true,
          ""
        );
        if (response?.data) {
          const domainList = response.data.map((item) => ({
            value: item.id,
            label: item.ten || item.name,
          }));
          setDomains(domainList);
        }
      } catch (error) {
        showToast.error("Không thể tải danh sách lĩnh vực báo cáo.");
      } finally {
        setLoading(false);
      }
    };

    fetchDomains();
  }, []);

  const handleChange = (e) => {
    const value = e.target.value;
    onDomainChange(value);
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-4">
      <div className="flex flex-col sm:flex-row justify-between items-stretch sm:items-center gap-3">
        <div className="w-full sm:w-60">
          <CustomSelect
            value={selectedDomain}
            onChange={(val) => onDomainChange(typeof val === 'object' ? val?.target?.value : val)}
            disabled={loading}
            placeholder="Tất cả lĩnh vực"
            options={[
              { value: "all", label: "Tất cả lĩnh vực" },
              ...domains
            ]}
          />
        </div>

        <ExportButtons dateRange={dateRange} reportType="reports" />
      </div>
    </div>
  );
}